var _rect, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1440 800",
    width: 1440,
    height: 800,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1440,
    height: 800,
    fill: "#0e100f"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#05a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 82L10.5 95C21 108 42 134 62.8 134C83.7 134 104.3 108 125.2 96.2C146 84.3 167 86.7 187.8 97.3C208.7 108 229.3 127 250.2 138.7C271 150.3 292 154.7 313 148.8C334 143 355 127 375.8 126.5C396.7 126 417.3 141 438.2 137.7C459 134.3 480 112.7 500.8 106.5C521.7 100.3 542.3 109.7 563.2 109.5C584 109.3 605 99.7 626 104.7C647 109.7 668 129.3 688.8 140.7C709.7 152 730.3 155 751.2 141.2C772 127.3 793 96.7 814 99.2C835 101.7 856 137.3 876.8 150.8C897.7 164.3 918.3 155.7 939.2 143C960 130.3 981 113.7 1001.8 105.5C1022.7 97.3 1043.3 97.7 1064.2 99.8C1085 102 1106 106 1127 113.5C1148 121 1169 132 1189.8 126.7C1210.7 121.3 1231.3 99.7 1252.2 103.5C1273 107.3 1294 136.7 1314.8 145.8C1335.7 155 1356.3 144 1377.2 134.2C1398 124.3 1419 115.7 1429.5 111.3L1440 107L1440 0L1429.5 0C1419 0 1398 0 1377.2 0C1356.3 0 1335.7 0 1314.8 0C1294 0 1273 0 1252.2 0C1231.3 0 1210.7 0 1189.8 0C1169 0 1148 0 1127 0C1106 0 1085 0 1064.2 0C1043.3 0 1022.7 0 1001.8 0C981 0 960 0 939.2 0C918.3 0 897.7 0 876.8 0C856 0 835 0 814 0C793 0 772 0 751.2 0C730.3 0 709.7 0 688.8 0C668 0 647 0 626 0C605 0 584 0 563.2 0C542.3 0 521.7 0 500.8 0C480 0 459 0 438.2 0C417.3 0 396.7 0 375.8 0C355 0 334 0 313 0C292 0 271 0 250.2 0C229.3 0 208.7 0 187.8 0C167 0 146 0 125.2 0C104.3 0 83.7 0 62.8 0C42 0 21 0 10.5 0L0 0Z",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fill: "url(#gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.2df65ee16d65197097fbb7f8422d55e1.svg";
export { ForwardRef as ReactComponent };